import InputSearch from './search';
import InputPrice from './price';

class Input {}

Input.Search = InputSearch;
Input.PriceFilter = InputPrice;

export default Input;


// WEBPACK FOOTER //
// ./src/components/input/index.js